import React from 'react'
import ReactDOM from 'react-dom/client'
import { get_app_config } from './data'
import './index.css'
import AppContainer from './AppContainer'
import { isEmpty } from './utils'

const roots = document.querySelectorAll('[data-rsa-survey-root]')
roots.forEach(root => {
  const app = ReactDOM.createRoot(root)
  const app_config = get_app_config()
  const config_override = {
    DisplayAsModal: !isEmpty(root.getAttribute('data-modal')) ? parseInt('' + root.getAttribute('data-modal') || '') === 1 : app_config.config.DisplayAsModal,
    ModalButtonText: !isEmpty(root.getAttribute('data-modal-button-text')) ? root.getAttribute('data-modal-button-text')! : app_config.config.ModalButtonText,
    AutoNext: !isEmpty(root.getAttribute('data-auto-next')) ? parseInt('' + root.getAttribute('data-auto-next') || '') === 1 : app_config.config.AutoNext,
    Theme: {
      HighlightColor: !isEmpty(root.getAttribute('data-highlight-color')) ? root.getAttribute('data-highlight-color')! : app_config.config.Theme.HighlightColor,
      ContrastColor: !isEmpty(root.getAttribute('data-contrast-color')) ? root.getAttribute('data-contrast-color')! : app_config.config.Theme.ContrastColor,
    },
  }
  app.render(
    <React.StrictMode>
      <AppContainer {...{ ...app_config, config: { ...app_config.config, ...config_override } }} />
    </React.StrictMode>
  )
})
